import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getMenuCode } from '@/services/menuCode/apis'
import { useCallback } from 'react'

const GET_MENU_CODE_KEY = ['MENU_CODE']

export const useGetMenuCode = (menuCode = '') => {
  const queryClient = useQueryClient()

  const { data, ...rest } = useQuery({
    queryKey: GET_MENU_CODE_KEY,
    queryFn: () => getMenuCode({ menuCode }),
    enabled: false,
  })

  const reset = useCallback(() => {
    queryClient.removeQueries({ queryKey: GET_MENU_CODE_KEY })
  }, [])

  return {
    ...rest,
    data: data?.data.items ?? [],
    reset,
  }
}
